import { Component, OnInit } from '@angular/core';
import {RemitToModel} from './../../../../models/RemitTo';
import { NgForm, FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from './../../../../services/vendor.service';
import { DataService } from './../../../../services/data.service';
import { AccountService } from './../../../../services/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginResult } from '../../../../models/LoginResult';
@Component({
  selector: 'app-remit-to',
  templateUrl: './remit-to.component.html',
  styleUrls: ['./remit-to.component.scss']
})
export class RemitToComponent implements OnInit {
  public remitInfo: RemitToModel = new RemitToModel();
  public successMsg: string;
  errorMsg: string;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  alive = true;
  userInfo: LoginResult;
  constructor(private dataSvc: DataService,
    private vendorSvc: VendorService,
    private accountSvc: AccountService,
    private spinner: NgxSpinnerService,
    private router: Router) {
      this.userInfo = dataSvc.userDisplayInfo;
     }

  ngOnInit() {
    console.log("GPVID", this.userInfo.GPVID.trim());
  }

  onSubmit(frmVendorRemit:NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();
    console.log("Submit  activated", frmVendorRemit);
    console.log(frmVendorRemit.value);
    frmVendorRemit.value.gPVID = this.userInfo.GPVID.trim();
    console.log(frmVendorRemit.value);
    this.vendorSvc.updateVendorRemitToInfo(frmVendorRemit)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.showSuccessConfirmation = true;
          this.successMsg = 'Remit To Information Submitted';
          this.showFailConfirmation = false;
          this.spinner.hide();
        },
        err => {
          this.errorMsg = err;
          this.showSuccessConfirmation = false;
          this.showFailConfirmation = true;
          this.spinner.hide();
        },
        () => console.log('Request Complete')
      );
  }
  goToMyVendor(event) {
    this.router.navigate(['/pages/vendor/myvendor/home']);
  }

  close(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  public ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/remit-to/remit-to.component.ts